import React, { useEffect, useState } from 'react';

const FloatingButton: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 200);
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return visible ? (
    <button
      className="floating-button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      ⬆
    </button>
  ) : null;
};

export default FloatingButton;